module.exports = __webpack_public_path__ + "img/Vector.3faf8c0e.svg";